import ProviderAPI from "../redux/ProviderAPI";

export const getUtilityType = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/utilities/getUtilityType",
    data,
    token,
  });
  return result;
};

export const addPricePerUnitToMonth = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/utilities/addPricePerUnitToMonth",
    data,
    token,
  });
  return result;
};

export const addUtilities = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/utilities/addUtilities",
    data,
    token,
  });
  return result;
};

export const getPricePerUnitToMonth = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/utilities/getPricePerUnitToMonth",
    data,
    token,
  });
  return result;
};

export const editPricePerUnitToMonth = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/utilities/editPricePerUnitToMonth",
    data,
    token,
  });
  return result;
};

export const editUtilities = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/utilities/editUtilities",
    data,
    token,
  });
  return result;
};

export const getUtilities = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/utilities/getUtilities",
    data,
    token,
  });
  return result;
};

export const getUtilitiesMergeBill = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/utilities/getUtilitiesMergeBill",
    data,
    token,
  });
  return result;
};